<template>
    <div class="home">
        <!-- <video-background/> -->
        <i-slides />
        <!-- <i-font-tester :fonts="[{fontFamily:'Plumb',fontWeight:'light',fontSize:'24px'},{fontFamily:'Plumb',fontWeight:'normal',fontSize:'24px'},{fontFamily:'Plumb',fontWeight:'medium',fontSize:'24px'},{fontFamily:'Plumb',fontWeight:'bold',fontSize:'24px'}]"/> -->
        <br />
        <br />
        <h2 class="u-c text-center">{{tr.latest_publications}}</h2>
        <posts-grid :posts="postsOnMainPage" :paginator="false" />
        <div class="text-center"><a href="#/posts" class='watch-all'>{{tr.watch_all}}</a></div>
        <br>
        <h2 class="u-c text-center">{{tr.main_events}}</h2>
        <posts-grid :posts="eventsOnMainPage" :paginator="false" />
        <div class="text-center"><a href="#/events" class='watch-all'>{{tr.watch_all}}</a></div>
        <br>
        <br>
        <most-popular />
        <ruhani />
        <video-box />
        <fond />
        <astana-club />
        <div class="five-inits">
            <div class="container">
                <div class="baner">
                    <a href="http://www.akorda.kz/ru/speeches/internal_political_affairs/in_speeches_and_addresses/obrashchenie-prezidenta-respubliki-kazahstan-nanazarbaeva-k-narodu-pyat-socialnyh-iniciativ-prezidenta" target="_blank">
						<img src="../assets/img/5_init.png" alt="5 социальных инициатив президента">
					</a>
                </div>
                <div class="baner">
                    <a href="http://www.akorda.kz/ru/events/astana_kazakhstan/participation_in_events/poslanie-prezidenta-respubliki-kazahstan-lidera-nacii-nursultana-nazarbaeva-narodu-kazahstana-strategiya-kazahstan-2050-novyi-politicheskii-" target="_blank">
						<img src="../assets/img/2050-lg.png" alt="Казахстан 2050">
					</a>
                </div>
                <div class="baner">
                    <a href="http://www.akorda.kz/ru/addresses"  target="_blank">
						<img src="../assets/img/akorda-small.jpg" alt="Послания президента" style='border-radius:6px;'>
					</a>
                </div>
                <div class="baner">
                    <a href="http://www.akorda.kz/ru/addresses/addresses_of_president/poslanie-prezidenta-respubliki-kazahstan-nnazarbaeva-narodu-kazahstana-31-yanvarya-2017-g" target="_blank">
						<img src="../assets/img/modern.png" alt="Модернизация 3.0">
					</a>
                </div>
            </div>
        </div>
        <div>
            <!-- <div class="fb-page" data-href="https://www.facebook.com/kz.iwep/" data-tabs="timeline" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true"><blockquote cite="https://www.facebook.com/kz.iwep/" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/kz.iwep/">ИМЭП / Институт мировой экономики и политики</a></blockquote></div> -->
        </div>
    </div>
</template>
<script>
import iSlides from "./slides.vue";
import PostsGrid from "./posts-grid.vue";
import Ruhani from "./ruhani.vue";
import AstanaClub from "./astana-club.vue";
import MostPopular from "./most-popular.vue";
import VideoBox from "./video-box.vue";
//import VideoBackground from "./video-background.vue";
import fond from "./fond.vue";
export default {
    components: { iSlides, PostsGrid, Ruhani, AstanaClub, MostPopular, VideoBox, fond },
    name: 'home',
    computed: {
        lang() { return this.$store.state.lang; },
        tr() { return this.$store.getters.translates; },
        postsOnMainPage() {
            let { lang } = this;
            return this.$store.getters.publications.filter(p => { return p.content[lang] && p.content[lang].enabled }).slice(0, 6);
        },
        eventsOnMainPage() {
            let { lang } = this;

            return this.$store.getters.events.filter(p => { return p.content[lang] && p.content[lang].enabled }).slice(0, 6);
        },
        seo() { return { title: this.trRaw.home_page, description: this.trRaw.home_page_meta_description } }
    },
    data() {
        return {
            //five_inits_logo: require('../assets/img/5_init.png'),
            five_inits_logo: require('../assets/img/2050-lg.png'),
            akorda_logo: require('../assets/img/akorda-small.jpg'),
            modern: require('../assets/img/modern.png')

        }
    }

}
</script>
<style scoped>
.five-inits {
    padding: 30px 0;
    overflow: hidden;
}

.five-inits .baner {
    width: 25%;
    float: left;
    text-align: center;
    margin: 4px 0;

}

@media(max-width:767px) {
    .five-inits .baner {
        width: 50%;
    }
}

.five-inits .baner img {
    max-width: 100%;
    vertical-align: middle;
    max-height: 60px;
}


.watch-all {
    text-decoration: none;
    font-size: 18px;
    font-weight: bold;
    text-transform: uppercase;
    color: black;
}
</style>